import { builtInButtons } from "../../default-tour-options";

export const steps = [
  {
    buttons: [
      builtInButtons.cancel,
      builtInButtons.next
    ],
    classes: 'custom-class-name-1 custom-class-name-2',
    id: 'intro',
    title: 'Hardware Register',
    text: `
      <p>On this page is a table of registered drives and another for scanners.</p>
      <p>You will also use this page to mark any hardware as being sent back to Insurgo.</p>`
  }
];
